import React, { useEffect, useState } from 'react';
import loadjs from 'loadjs';
import Loader from '../common/Loader';

const CheckAvailability = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    let lqUrl = '';
    let lqTagging = '';
    if (window.location.host === 'www.verizon.com') {
      lqUrl = 'https://www.verizon.com/inhome/vzlqwidget.js';
      lqTagging = '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-72284e178e44.min.js';
    } else {
      lqUrl = 'https://www98.verizon.com/inhome/vzlqwidget.js';
      lqTagging = '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-61f2528ef72a-development.min.js';
    }
    window.vzwlqwidgetconfig = {
      targetElementId: 'lq-widget-root',
      lqApi: 'LOCUS_API',
      platform: '5G',
      flowType: '',
      sourceInfo: 'external',
      renderSettings: {
        mode: 'modal',
        externalTrigger: ['#checkLq'],
        miniLq: {
          enabled: false,
          layout: {},
        },
      },
    };
    loadjs(lqUrl, { returnPromise: true }).then(() => {
      const interval = setInterval(() => {
        if (window.vzlqw && window.vzlqw.openModal) {
          clearInterval(interval);
          setLoaderStatus(false);
          window.vzlqw.openModal();
        }
      }, 4);
    });
    loadjs(lqTagging);
  }, []);
  return (
    <div>
      <div id="lq-widget-root" />
      <Loader active={loaderStatus} fullscreen={loaderStatus} />
    </div>
  );
};

export default CheckAvailability;
